import { BankingContractReturnMetrics } from "../../../../models/banking";

function KpiCard({
  label,
  value,
  unit,
  hint,
  hintTone,
  dotColor,
}: {
  label: string;
  value: string;
  unit?: string;
  hint?: string;
  hintTone?: "neg" | "muted";
  dotColor: string;
}) {
  return (
    <div className="bg-white border border-[#E8EAEF] rounded-[10px] px-3.5 py-3 flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <span className="text-[11px] tracking-wider text-[#828A99] font-semibold">
          {label}
        </span>
        <span
          className="w-2 h-2 rounded-full inline-block"
          style={{ background: dotColor }}
        />
      </div>
      <div className="text-[24px] font-bold text-[#525062] leading-tight">
        {value}
        {unit && (
          <span className="text-[12px] font-medium text-[#828A99] ml-1">
            {unit}
          </span>
        )}
      </div>
      {hint && (
        <div
          className={`text-[11px] ${
            hintTone === "neg" ? "text-[#E0463C] font-medium" : "text-[#828A99]"
          }`}
        >
          {hint}
        </div>
      )}
    </div>
  );
}

const fmt = (n: number) =>
  Number.isFinite(n) ? n.toLocaleString(undefined, { maximumFractionDigits: 2 }) : "—";

export function ReturnKpiRow({
  metrics,
}: {
  metrics: BankingContractReturnMetrics;
}) {
  const hoursPerDay = metrics.return_days
    ? +(metrics.total_return_hours / metrics.return_days).toFixed(2)
    : 0;
  return (
    <div className="grid grid-cols-4 gap-3 mb-3.5 mt-3.5">
      <KpiCard
        label="RETURN REQUIRED"
        value={fmt(metrics.return_required_mwh)}
        unit="MWh"
        hint={`${metrics.banking_factor_pct}% factor`}
        dotColor="#6366F1"
      />
      <KpiCard
        label="RETURN GIVEN"
        value={fmt(metrics.return_given_total_mwh)}
        unit="MWh"
        hint={`Scheduled ${fmt(metrics.return_given_scheduled_mwh)} MWh`}
        dotColor="#0EA5A4"
      />
      <KpiCard
        label="RETURN LEFT"
        value={fmt(metrics.return_left_mwh)}
        unit="MWh"
        hint={`Daily avg ${fmt(metrics.daily_avg_return_mwh)} MWh`}
        hintTone={metrics.return_left_mwh > 0 ? "neg" : "muted"}
        dotColor="#E2682B"
      />
      <KpiCard
        label="AVG RETURN"
        value={fmt(metrics.avg_return_mw)}
        unit="MW"
        hint={`${metrics.return_days}d × ${hoursPerDay}h`}
        dotColor="#B47817"
      />
    </div>
  );
}

export default ReturnKpiRow;
